import { connect } from "react-redux";
import { IState } from "../../../App/reducer";
import { HTMLEditorComponent } from "./Editor.component";
import { IHTMLEditorOwnProps, IHTMLEditorStateProps } from "./types";

const mapStateToProps = (state: IState) => ({
  mediaFiles: state.App.CourseAuthor._.resolvedData.mediaFiles,
  uploadFile: state.App.CourseAuthor._.fileUploadApi.uploadFile,
  uploadFileViaUrl: state.App.CourseAuthor._.fileUploadApi.uploadFileViaUrl,
});

export const HTMLEditor = connect<IHTMLEditorStateProps, {}, IHTMLEditorOwnProps, IState>(mapStateToProps, null, null, {
  forwardRef: true,
})(HTMLEditorComponent);
